import React, { useState, useEffect } from 'react';
import './myProfile.css';
import CustomSelect from '../customSelect/customSelect';
import apiService from '../../../services/apiService';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomToast from '../../Toast';
import { useTranslation } from 'react-i18next';

const EditProfileForm = ({ onClose }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [selectedGender, setSelectedGender] = useState('');
  const [phone, setPhone] = useState('');
  const [selectedAgeGroup, setSelectedAgeGroup] = useState('');
  const [designation, setDesignation] = useState('');
  const [department, setDepartment] = useState('');
  const [userLocation, setUserLocation] = useState('');
  const [emailError, setEmailError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState('');
  const [removeImage , setImageRemove] = useState(false)
  const location = useLocation();
  const navigate = useNavigate()
  const { t } = useTranslation();

  const fetchData = async () => {
    try {

      const token = apiService.getAuthToken();
      let userDetails  = sessionStorage.getItem('user_details')
      if(userDetails) {
          userDetails = JSON.parse(userDetails)
          const result = userDetails
          setImagePreview(result?.pic && result?.pic != "null"  && result?.pic != null ? result?.pic : '')
          setUserData(result);
          setName(result?.name)
          setEmail(result?.email && result?.email != "null" ? result?.email : '')
          setSelectedGender(result?.gender && result?.gender != "null" ? result?.gender : '')
          setPhone(result?.mobile && result?.mobile != "null" ? result?.mobile : '')
          setSelectedAgeGroup(result?.age_group && result?.age_group != "null" ? result?.age_group : '')
          setDesignation(result?.designation && result?.designation != "null" ? result?.designation : '')
          setDepartment(result?.department && result?.department != "null" ? result?.department : '')
          setUserLocation(result?.location && result?.location != "null" ? result?.location : '')
      } else {
        const result = await apiService.get('get-org-user-info', token);
        if (result && result.status === 'success') {
          setImagePreview(result?.data?.pic && result?.data?.pic != "null"  && result?.data?.pic != null ? result?.data?.pic : '')
          setUserData(result.data);
          setName(result.data.name)
          setEmail(result?.data?.email && result?.data?.email != "null" ? result?.data?.email : '')
          setSelectedGender(result?.data?.gender && result?.data?.gender != "null" ? result?.data?.gender : '')
          setPhone(result?.data?.mobile && result?.data?.mobile != "null" ? result?.data?.mobile : '')
          setSelectedAgeGroup(result?.data?.age_group && result?.data?.age_group != "null" ? result?.data?.age_group : '')
          setDesignation(result?.data?.designation && result?.data?.designation != "null" ? result?.data?.designation : '')
          setDepartment(result?.data?.department && result?.data?.department != "null" ? result?.data?.department : '')
          setUserLocation(result?.data?.location && result?.data?.location != "null" ? result?.data?.location : '')
        }
      }
    } catch (error) {
    
      setError(t('toast_messages_user_details_fetching_error'));
      console.error(error);
      console.log("error", error)
      // CustomToast.error('Error fetching user data'); 
      if (error == "Invalid token id!") {
        // Clear the token from local storage
        localStorage.removeItem('authToken');
        sessionStorage.removeItem('user_details');
        // Redirect to the original website
        // if (process.env.REACT_APP_ENV == "development") {
        //     window.location.href = 'https://staging.inclusional.com';
        // } else {
        //     window.location.href = 'https://site.inclusional.com';
        // }
        window.location.href = process.env.REACT_APP_LOGIN_URL
        //process.env.REACT_APP_LOGIN_URL
    }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const ageGroupOptions = [
    { value: 'Boomers: 1946 - 1964', label: 'Boomers: 1946 - 1964' },
    { value: 'Gen X: 1965 - 1980', label: 'Gen X: 1965 - 1980' },
    { value: 'Millenials: 1981 - 1996', label: 'Millenials: 1981 - 1996' },
    { value: 'Gen Z: 1997 - 2012', label: 'Gen Z: 1997 - 2012' },
    { value: 'Alpha: 2013 - 2025', label: 'Alpha: 2013 - 2025' },
    { value: 'Prefer not to state', label: 'Prefer not to state'},
];

const genderOptions = [
    { value: 'Woman', label: 'Woman' },
    { value: 'Man', label: 'Man' },
    { value: 'Others', label: 'Others' },
    { value: 'Prefer not to state', label: 'Prefer not to state'},
  ];

  const handleChange = (e, setState, validator) => {
    const { name, value } = e.target;
    setState(value);
    if (validator) {
      validator(value);
    }
  };

  const handlePhoneChange = (e) => {
    let newPhoneNumber = e.target.value;
    
    // Remove any non-digit characters
    newPhoneNumber = newPhoneNumber.replace(/\D/g, '');
    
    // Limit to 10 digits
    if (newPhoneNumber.length > 10) {
      newPhoneNumber = newPhoneNumber.slice(0, 10);
    }
    
    setPhone(newPhoneNumber);
    
    // Only validate if user has started typing
    if (newPhoneNumber.length > 0) {
      validatePhone(newPhoneNumber);
    } else {
      setPhoneError(''); // Clear error if field is empty
    }
};

    const handleEmailChange = (e) => {
        const newEmail = e.target.value;
        setEmail(newEmail);
        validateEmail(newEmail);
    };

    const handleAgeGroupChange = (value) => {
        setSelectedAgeGroup(value);
    };

    const handleGenderChange = (value) => {
        setSelectedGender(value);
    };

  const validateEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailPattern.test(email);
    setEmailError(isValid ? '' : t('toast_messages_valid_email_address'));
    return isValid
  };

  const validatePhone = (phone) => {
    if (!phone || phone.trim() === '') {
      setPhoneError('');
      return true; // Allow empty phone as it's optional
    }
    
    // Remove any non-digit characters for validation
    const cleanedPhone = phone.replace(/\D/g, '');
    
    if (cleanedPhone.length < 10) {
      setPhoneError('Mobile number must be at least 10 digits');
      return false;
    } else if (cleanedPhone.length > 10) {
      setPhoneError('Mobile number cannot exceed 10 digits');
      return false;
    } else if (!/^[0-9]{10}$/.test(cleanedPhone)) {
      setPhoneError(t('toast_messages_valid_phone_number'));
      return false;
    }
    
    setPhoneError('');
    return true;
  };

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      const allowedExtensions = ['.png', '.jpg', '.jpeg'];
      const extension = selectedFile.name.split('.').pop().toLowerCase();
      if (allowedExtensions.includes('.' + extension)) {
        setSelectedImage(selectedFile);
        setImagePreview(URL.createObjectURL(selectedFile));
      } else {
        CustomToast.info(t('toast_messages_valid_image_file'));
      }
    }
  };

  const validateEmailOrPhone = (email, phone) => {
    if (!email && !phone) {
        CustomToast.error('Email ID or Mobile is a mandatory field.');
        return false;
    }
    return true; 
}

const handleSubmit = async(e) => {
    e.preventDefault()

    // Validate phone if it's provided
    if (phone && phone.trim() !== '' && !validatePhone(phone)) {
        CustomToast.error('Please enter a valid 10-digit mobile number');
        return;
    }
    
    // Validate email if it's provided  
    if (email && email.trim() !== '' && !validateEmail(email)) {
        CustomToast.error('Please enter a valid email address');
        return;
    }
    
    if(!validateEmailOrPhone(email, phone)){
        return;
    }
  
    // Create FormData object
    const formData = new FormData();
    formData.append('name', name);
    // formData.append('email', email);
    if(email && email != "null" && email != "undefined"){
      formData.append('email', email);
    } else {
      formData.append('email', null);
    }
    if(selectedGender && selectedGender != "null" && selectedGender != "undefined"){
      formData.append('gender', selectedGender);
    } else {
      formData.append('gender', 'Prefer not to state'); 
    }
    // formData.append('mobile', phone);
    if(phone && phone != "null" && phone != "undefined"){
      formData.append('mobile', phone);
    } else {
      formData.append('mobile', null);
    }

    if(selectedAgeGroup && selectedAgeGroup != "null" && selectedAgeGroup != "undefined"){
      formData.append('age_group', selectedAgeGroup);
    } else {
      formData.append('age_group', 'Prefer not to state'); 
    }
    if(designation && designation != "null" && designation != "undefined"){
      formData.append('designation', designation);
    }
    if(department && department != "null" && department != "undefined") {
      formData.append('department', department);
    }
    if(userLocation && userLocation != "null" && userLocation != "undefined") {
      formData.append('location', userLocation);
    }
    
    if(selectedImage) {
      formData.append('image', selectedImage);
    } else {
      if(removeImage) {
        formData.append('image', null);
      }
    }
    // Make API call to update user profile
    try {
      const token = apiService.getAuthToken();
      const response = await apiService.put('update-org-user-info', formData, token);
  
      if (response && response.status === 'success') {
        // Handle success, e.g., show a success message or redirect
        CustomToast.success(t('toast_messages_profile_updated_success')); 
        onClose();
        navigate("/my_profile")
        
      } else {
        // Handle API error
        setError(t('toast_messages_update_profile_failed'));
        CustomToast.error(t('toast_messages_update_profile_failed')); 
      }
    } catch (error) {
      // Handle other errors (network, etc.)
      setError(t('toast_messages_error_updating_profile'));
      console.error(error);
      CustomToast.error(t('toast_messages_error_updating_profile')); 
    }
  };


  const handleRemoveImage = async ()=> {
    setSelectedImage(null);
    setImagePreview(null);
    setImageRemove(true)
  }

  const getInitials = (name) => {
    return name?.split(' ').map(word => word.charAt(0)).join('').toUpperCase() || '';
 };

  const handleClose = () => {
    onClose();
  };

  let userDetails = sessionStorage.getItem('userDetail')
    if(userDetails) {
        userDetails = JSON.parse(userDetails)
      // console.log(userDetails?.org_id)
    }
   // console.log("userDetails :", userDetails);

  return (
    <div className='profile-bg-container'>
      <div className='profile-form-wrapper mx-auto pb-1 mt-5'>
        <h3 className='font-weight-600 font-20 mx-3'>{t('my_profile_edit_profile')}</h3>
        <div className="card p-lg-3 p-0 mt-4 mb-5 mx-2 shadow">
          <div className="card-body ">
            <form onSubmit={handleSubmit}>
              <div className='row'>
                <div className="form-group w-100 text-center mb-4 mt-4">
                  <label className='custom-image-upload'>
                    {!imagePreview && userData && userData?.name ? (
                      <span className='username-initials fw-bolder font-28 text-white'>{getInitials(userData?.name)}</span>
                    ) : null}

                    {imagePreview && (
                      <>
                        <img src={imagePreview} className='img-wrap' alt="Thumb" />
                        <div className="form-group w-100 text-center mb-4">
                          <span onClick={handleRemoveImage}>
                            <img src="/images/delete.png" className='remove-pic'></img>
                          </span>
                        </div>
                      </>

                    )}
                  </label>

                  {!imagePreview && userData && userData?.name ? (
                    <label className='upload-profile-pic'>
                      <img src="/images/camera_icon.png" className='add-pic'></img>
                      <input
                        accept="image/*"
                        name="selectedImage"
                        type="file"
                        onChange={handleImageChange}
                      />
                    </label>
                  ) : null}
                </div>
              </div>
              <div className='row'>
                <div className="col-lg-6 form-group mb-3">
                  <label className='mb-2'>{t('my_profile_name')}*</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder='Name'
                    value={name}
                    name="name"
                    onChange={(e) => setName(e.target.value)}
                    required />
                </div>
                <div className="col-lg-6 form-group mb-3">
                  <label className='mb-2'>{t('my_profile_email_id')}*</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder='Org. Email ID'
                    value={email}
                    name="email"
                    onChange={handleEmailChange}
                    disabled />
                  {emailError && <p className="error">{emailError}</p>}
                </div>
                {/* </div>
            <div className='row'> */}

                <div className="col-lg-6 form-group mb-3">
                  <label className='mb-2'>{t('my_profile_mobile')}</label>
                  <input
                    type="tel"
                    className="form-control"
                    placeholder='Enter mobile number'
                    value={phone}
                    name="phone"
                    onChange={handlePhoneChange}
                    maxLength="10"
                    inputMode="numeric"
                  />
                  {phoneError && <p className="error">{phoneError}</p>}
                </div>

                {userDetails && userDetails?.org_id != '7c13b617-55a1-4ea6-810a-7bf05aaf52af' ?
                  <div className="col-lg-6 form-group age mb-3">
                    <label htmlFor="ageSelect" className='mb-2'>{t('my_profile_age_group')}</label>
                    <CustomSelect
                      name="selectedAgeGroup"
                      placeholder="Choose Your Age Group"
                      options={ageGroupOptions}
                      value={selectedAgeGroup}
                      onChange={handleAgeGroupChange}
                    />
                  </div> : ' '}
                {/* </div>
            <div className='row'> */}
                {userDetails && userDetails?.org_id != '7c13b617-55a1-4ea6-810a-7bf05aaf52af' ?
                  <div className="col-lg-6 form-group gender mb-3">
                    <label htmlFor="genderSelect" className='mb-2'>{t('my_profile_gender')}</label>
                    <CustomSelect
                      name="selectedGender"
                      placeholder='Select Gender'
                      options={genderOptions}
                      value={selectedGender}
                      onChange={handleGenderChange}
                    />
                  </div> : ' '}

                <div className="col-lg-6 form-group mb-3">
                  <label className='mb-2'>{t('my_profile_department')}</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder='e.g. IT'
                    value={department}
                    name="department"
                    onChange={(e) => setDepartment(e.target.value)}
                    disabled
                  />
                </div>
                {/* </div>
            <div className='row'> */}
                <div className="col-lg-6 form-group mb-3">
                  <label className='mb-2'>{t('my_profile_designation')}</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder='e.g. Manager'
                    value={designation}
                    name="designation"
                    onChange={(e) => setDesignation(e.target.value)}
                    disabled
                  />
                </div>
                <div className="col-lg-6 form-group mb-3 location">
                  <label className='mb-2'>{t('my_profile_location')}</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder='e.g. Pune'
                    value={userLocation}
                    name="userLocation"
                    onChange={(e) => setUserLocation(e.target.value)}
                    disabled
                  />
                </div>
              </div>

              <div className='d-flex justify-content-end mt-4 border-top pt-4 '>
                <button type='button' onClick={handleClose} className='btn btn-md btn-secondary rounded-pill mt-1 me-2'>{t('my_profile_cancel')}</button>
                <button type='submit' className='btn btn-md btn-primary rounded-pill mt-1'>{t('my_profile_save')}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProfileForm;